import { render, staticRenderFns } from "./BFormInputPassword.vue?vue&type=template&id=241d295c&scoped=true"
import script from "./BFormInputPassword.vue?vue&type=script&lang=js"
export * from "./BFormInputPassword.vue?vue&type=script&lang=js"
import style0 from "./BFormInputPassword.vue?vue&type=style&index=0&id=241d295c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241d295c",
  null
  
)

export default component.exports